module.exports = __webpack_public_path__ + "res/ic_camera.d417408e4c7ddd5dc208bd224b05a2ad.png";